import { Pipe, PipeTransform } from '@angular/core';
import { TableColumn } from '@thehubz/client/core';

@Pipe({
  name: 'columnVisible',
})
export class ColumnVisiblePipe implements PipeTransform {
  transform(tableCols: TableColumn[]): TableColumn[] {
    if (!tableCols) {
      return [];
    }
    const filteredTableCols = tableCols.filter((item) => item.visible);
    return filteredTableCols.length ? filteredTableCols : tableCols;
  }
}
